// extracted by mini-css-extract-plugin
module.exports = {"container":"tNqFA8 mz-default-dark-font"};